import { defineSlotRecipe } from '@chakra-ui/react'

const white = 'brand.white'
const darkCityGreen = 'brand.darkCityGreen'

export const stickyBanner = defineSlotRecipe({
  className: 'StickyBanner',
  slots: ['banner', 'container', 'crossIcon', 'message', 'messageWrapper', 'wrapper', 'icon'],
  base: {
    wrapper: { backgroundColor: 'brand.teal5' },
    banner: {},
    icon: { color: 'brand.primaryTeal' },
    message: {
      color: 'brand.black',
    },
    crossIcon: {},
  },
  variants: {
    variant: {
      ERROR: {
        message: {
          color: white,
        },
        icon: { color: white },
        wrapper: {
          backgroundColor: 'brand.red',
          color: white,
        },
        crossIcon: {
          ':focus-visible': {
            outlineColor: white,
          },
        },
      },
      INFO: {
        icon: { color: darkCityGreen },
        wrapper: {
          color: darkCityGreen,
        },
      },
      SUCCESS: {
        icon: { color: darkCityGreen },
        wrapper: {
          color: darkCityGreen,
        },
      },
      WARNING: {
        icon: { color: 'brand.red' },
        wrapper: {
          backgroundColor: 'brand.red5',
          color: 'brand.red',
        },
      },
      PROMOTION: {
        message: {
          color: 'brand.primaryTeal',
        },
      },
    },
  },
})
